export default {
  CALENDAR_TYPE_DATE_TIME: 0,
  CALENDAR_TYPE_WEEKDAY_TIME: 1,
  CALENDAR_TYPE_DAY_TIME: 2,
  CALENDAR_TYPE_HOUR_TIME: 3
};
